<template>
  <div class="lang-switcher" :class="mode">
    <div v-if="mode === 'row'" class="lang-row" @click="open">
      <div class="left">{{ $t('语言切换器.切换语言') }}</div>
      <div class="right">
        <span class="desc">{{ currentLangName }}</span>
        <van-icon name="arrow" />
      </div>
    </div>
    <div v-else-if="mode === 'nav'" class="nav-entry" @click.stop="open">
      <van-icon name="guide-o" class="nav-icon" />
      <div class="text_c">{{ $t('语言切换器.语言') }}</div>
    </div>
    <van-button
      v-else
      class="chip-btn"
      hairline
      plain
      size="small"
      @click="open"
    >
      {{ currentLangName }}
      <van-icon name="arrow-down" class="lang-icon" />
    </van-button>

    <van-action-sheet
      v-model="show"
      :actions="actions"
      :cancel-text="$t('抢单.取消')"
      close-on-click-action
      get-container="body"
      @select="onSelect"
    />
  </div>
</template>

<script>
import { LANGUAGES, setLanguage } from '@/lang'

export default {
  name: 'LanguageSwitcher',
  props: {
    mode: {
      type: String,
      default: 'chip',
    },
  },
  data() {
    return {
      show: false,
    }
  },
  computed: {
    currentCode() {
      return this.$i18n.locale
    },
    currentLangName() {
      const cur = LANGUAGES.find(v => v.code === this.currentCode)
      return cur ? cur.name : this.currentCode
    },
    actions() {
      return LANGUAGES.map(v => ({
        name: v.name,
        code: v.code,
        color: v.code === this.currentCode ? '#e6b98a' : '',
      }))
    },
  },
  methods: {
    open() {
      this.show = true
    },
    onSelect(action) {
      if (!action || !action.code || action.code === this.currentCode) return
      setLanguage(action.code)
      this.$emit('change', action.code)
    },
  },
}
</script>

<style lang="less" scoped>
.lang-switcher {
  &.row {
    width: 100%;

    .lang-row {
      width: 100%;
      box-sizing: border-box;
      padding: 30px 0;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      font-size: 30px;
      color: #eee;
      line-height: 1.2;
    }

    .left {
      flex: 1;
      min-width: 0;
      color: #eee;
    }

    .right {
      flex-shrink: 0;
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-left: 20px;

      .desc {
        font-size: 30px;
        font-weight: 700;
        color: #979799;
        margin-right: 8px;
      }

      .van-icon {
        font-size: 30px;
        color: #979799;
      }
    }
  }

  &.nav {
    width: 100%;

    .nav-entry {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #e6b98a;
    }

    .nav-icon {
      font-size: 56px;
      line-height: 76px;
      height: 76px;
      color: #e6b98a;
    }

    .text_c {
      margin-top: 4px;
      font-size: 26px;
      color: #e6b98a;
    }
  }

  &.chip {
    display: inline-flex;

    .chip-btn {
      height: auto;
      padding: 4px 12px;
      border-color: #e6b98a;
      color: #e6b98a;
      font-size: 24px;
      line-height: 1.4;
      background: transparent;

      .lang-icon {
        margin-left: 4px;
        font-size: 20px;
        vertical-align: middle;
      }
    }
  }
}
</style>